import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { isDoNotTrack, getOtherOptionsFromWindow } from "../../../utils";
import { getUserDecision } from "../../getUserDecision";
/**
 * When the user has "Do not track" enabled and is allowed to use, let's
 * automatically save the dialog without any action.
 */

var preDecisionGatewayIsDoNotTrack = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _getOtherOptionsFromW, isRespectDoNotTrack, groups, essentialGroup, _groups$filter, _groups$filter2, essentialGroupObj, _iterator, _step, group, _iterator2, _step2, item;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _getOtherOptionsFromW = getOtherOptionsFromWindow(), isRespectDoNotTrack = _getOtherOptionsFromW.isRespectDoNotTrack, groups = _getOtherOptionsFromW.groups, essentialGroup = _getOtherOptionsFromW.essentialGroup;
            _groups$filter = groups.filter(function (_ref2) {
              var slug = _ref2.slug;
              return slug === essentialGroup;
            }), _groups$filter2 = _slicedToArray(_groups$filter, 1), essentialGroupObj = _groups$filter2[0];

            if (!(getUserDecision() !== false || !isRespectDoNotTrack)) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", false);

          case 4:
            // As soon we have a legitimate interest, we need to show the cookie banner
            _iterator = _createForOfIteratorHelper(groups);
            _context.prev = 5;

            _iterator.s();

          case 7:
            if ((_step = _iterator.n()).done) {
              _context.next = 29;
              break;
            }

            group = _step.value;

            if (!(group !== essentialGroupObj)) {
              _context.next = 27;
              break;
            }

            _iterator2 = _createForOfIteratorHelper(group.items);
            _context.prev = 11;

            _iterator2.s();

          case 13:
            if ((_step2 = _iterator2.n()).done) {
              _context.next = 19;
              break;
            }

            item = _step2.value;

            if (!(item.legalBasis === "legitimate-interest")) {
              _context.next = 17;
              break;
            }

            return _context.abrupt("return", false);

          case 17:
            _context.next = 13;
            break;

          case 19:
            _context.next = 24;
            break;

          case 21:
            _context.prev = 21;
            _context.t0 = _context["catch"](11);

            _iterator2.e(_context.t0);

          case 24:
            _context.prev = 24;

            _iterator2.f();

            return _context.finish(24);

          case 27:
            _context.next = 7;
            break;

          case 29:
            _context.next = 34;
            break;

          case 31:
            _context.prev = 31;
            _context.t1 = _context["catch"](5);

            _iterator.e(_context.t1);

          case 34:
            _context.prev = 34;

            _iterator.f();

            return _context.finish(34);

          case 37:
            return _context.abrupt("return", isDoNotTrack() ? "dnt" : false);

          case 38:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 31, 34, 37], [11, 21, 24, 27]]);
  }));

  return function preDecisionGatewayIsDoNotTrack() {
    return _ref.apply(this, arguments);
  };
}();

export { preDecisionGatewayIsDoNotTrack };